import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { User } from '@shared/types/user';
import { inputAssigneeStyles } from './inputAssigneeStyles';

export function MultiSelectUserRow({ user }: { user: User }) {
  const colors = useContext(ColorThemeContext);
  return (
    <View row centerVertically paddingVertical={1}>
      <MBUserImage style={inputAssigneeStyles.userImage} user={user} />
      <View flex centerVertically>
        <MBTextBody1 numberOfLines={1} color={colors.foregroundActive}>
          {user.fullName}
        </MBTextBody1>
      </View>
    </View>
  );
}
